import React, { forwardRef, Ref } from 'react';
import classNames from 'classnames';

import styles from './ButtonClean.module.scss';

export interface IButtonCleanProps
  extends React.ComponentPropsWithoutRef<'button'> {}

const ButtonClean = forwardRef(
  (
    { className, children, type = 'button', ...buttonProps }: IButtonCleanProps,
    ref: Ref<HTMLButtonElement>,
  ) => (
    <button
      className={classNames(styles.cleanButton, className)}
      ref={ref}
      type={type}
      {...buttonProps}
    >
      {children}
    </button>
  ),
);

ButtonClean.displayName = 'ButtonClean';

export default ButtonClean;
